<template>
  <PainelLayout>
    <Breadcrumb :lista="[
      { 'name':'Painel', 'link' : '/' },
      { 'name':'Categorias', 'link' : '/category' }]"
    />

    <h1 class="text-center" v-if="operation === 'store'">Nova Categoria</h1>
    <h1 class="text-center" v-if="operation === 'update'">Atualizar Categoria</h1>
    <!-- Div Formulario -->
    <div class="row" v-if="!loading">
      <div class="col-2"></div>
      <div class="col-12 col-md-8" >
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="categoryName">Nome da Categoria</label>
              <input @change="setLink()" v-model="category.name" required type="text" class="form-control" id="categoryName" placeholder="Digite o nome da categoria">
            </div>
          </div>
          <div class="col-12 mt-3">
            <div class="form-group">
              <label for="txtLink">Link</label>
              <input :style="!linkPersonalized ? 'background-color: #d1d1d1; color: gray;' : ''" :readonly="!linkPersonalized" v-model="category.link" required type="text" class="form-control" name="txtLink" id="txtLink">
              <label class="form-text mt-2" for="customLinkCheckbox">Link Personalizado?</label>
              <input type="checkbox" v-model="linkPersonalized" id="customLinkCheckbox" value="false">
            </div>
          </div>
          <div class="col-12 mt-3">
            <div class="form-group">
              <label for="categoryDescription">Descrição</label>
              <input v-model="category.description" type="text" class="form-control" id="categoryDescription" placeholder="Digite a descrição da categoria">
            </div>
          </div>
        </div>
      <div class="col-2"></div>
      </div>
      <!-- Div Botão Salvar -->
      <div class="row mt-4 text-center">
        <div class="col-12">
          <router-link class="btn btn-secondary me-2" to="/category">
            Voltar
          </router-link>
          <button @click="actionOperation" class="btn btn-primary me-2">
            <span>{{ operation === 'store' ? 'Salvar' : 'Atualizar' }}</span>
          </button>
          <button @click="clearForm" class="btn btn-secondary me-2">
            Limpar
          </button>
        </div>
      </div>
    </div>
    <!-- Div Loading -->
    <div v-else class="d-flex justify-content-center p-3 text-center">
      <div>
        <div class="spinner-border" style="width: 7rem; height: 7rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2" v-if="operation === 'update' && loading">Carregando dados da categoria...</p>
        <p class="mt-2" v-else-if="loading">Salvando categoria...</p>
      </div>
    </div>
  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import { onMounted, reactive, ref } from 'vue';
import { categories } from '@/models/categories';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import { useToastStore } from '@/stores/toastStore';
import { parseError } from '@/utils/errorHelper';
import router from '@/router';

export default {
  name: "NewCategoryView",
  components: { PainelLayout, Breadcrumb },
  setup(props) {

    const toastStore = useToastStore();
    var loading = ref(false);
    var operation = ref('store');
    const model = categories();

    const linkPersonalized = ref(false);

    const category = reactive({
      id: null,
      name: '',
      description: '',
      link: ''
    });

    onMounted(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const edit = urlParams.get('edit');
      const id = urlParams.get('id');

      if (edit && id) {
        document.title = `Atualizar Categoria - ${process.env.VUE_APP_NAME}`;

        operation.value = 'update';
        loading.value = true;
        model.getOne(id).then((response) => {
          category.id = response.id;
          category.name = response.name;
          category.description = response.description;
          category.link = response.link;
          loading.value = false;
        }).catch((error) => {
          toastStore.error('Erro ao carregar categoria: ' + parseError(error));
          loading.value = false;
        });
      }
    });

    function clearForm() {
      category.name = '';
      category.description = '';
      category.link = '';
      category.id = null;
      operation.value = 'store';
    };

    function setLink() {
      category.link = category.name.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
    };

    const actionOperation = () => {
      if (operation.value === 'update') {
        update();
      } else {
        if (!category.name) {
          toastStore.warning('O nome da categoria é obrigatório.');
          return;
        }
        store();
      }
    }

    function store() {
      loading.value = true;
      model.store(category).then(() => {
        toastStore.success('Categoria criada com sucesso!');
        loading.value = false;
        router.push('/category');
      }).catch((error) => {
        loading.value = false;
        toastStore.error('Erro ao criar categoria: ' + parseError(error));
      });
    }

    function update() {
      loading.value = true;
      model.update(category).then(() => {
        toastStore.success('Categoria atualizada com sucesso!');
        loading.value = false;
        router.push('/category');
      }).catch((error) => {
        toastStore.error('Erro ao atualizar categoria: ' + parseError(error));
        loading.value = false;
      });
    }

    return {
      category,
      actionOperation,
      operation,
      loading,
      linkPersonalized,
      setLink,
      clearForm
    }

  }
}
</script>